import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import {
  MDBContainer,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBDataTable,
} from "mdbreact";
import * as misConstantes from "../../../../../js/constantes.js";
import InicioBreadcrumbs from "../../../../../pages/template/breadcrumbs/InicioBreadcrumbs.js";

import {
  Switch,
  Route,
  BrowserRouter,
  Link,
  useLocation,
  useParams,
} from "react-router-dom";

import axios from "axios";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

class CotizacionTercero extends React.Component {
  constructor(props) {
    super(props);

    var url = window.location.href;
    var data = url.split("/");
    var idSimulacion = data[data.length - 2];
    var codigoCotizacion = data[data.length - 1];
    var linkSimulacion = "/simulacion/" + idSimulacion;

    var columnasCerrado = [
      { field: "texto", label: "Texto", attributes: { width: "45%" } },
      { field: "cantidad", label: "Cant", attributes: { width: "7%" } },
      {
        field: "precioSimulacion",
        label: "Simulación",
        attributes: { width: "10%" },
      },
      {
        field: "precioUnitarioAntesImpuestos",
        label: "Pre Uni",
        attributes: { width: "8%" },
      },

      {
        field: "totalImpuestosPositivos",
        label: "IVA",
        attributes: { width: "10%" },
      },
      { field: "descuento", label: "Descuento", attributes: { width: "10%" } },
      { field: "subtotal", label: "Subtotal", attributes: { width: "10%" } },
    ];

    var columnasArchivos = [
      { field: "nombre", label: "Nombre", attributes: { width: "30%" } },
      {
        field: "descripcion",
        label: "Descripcion",
        attributes: { width: "50%" },
      },
    ];

    this.state = {
      datos: { columns: columnasCerrado, rows: [] },
      columnasCerrado: columnasCerrado,
      mostrarEditarItemCotizacion: false,
      idEditarSimulador: -1,
      respuestaEditarItemCotizacion: "",
      respuestaEditarItemCotizacion: "",
      ivaEditar: "",
      precioUnitarioAntesImpuestos: "",
      descuentoPorcentajeEditar: "",
      precioUnitarioSimulacion: 0,
      requiereEdicionProveedor: false,
      columnas: columnasCerrado,
      mostrarIVATodosProductos: false,
      ivaTodosProductos: "",
      mostrarDescuentoTodosProductos: false,
      descuentoTodosProductos: "",
      cotizacion: {
        stotalIVA: "",
        stotalDescuento: "",
        stotal: "",
        ssubtotal: "",
      },
      cotizacion: {},

      mostrarCerrarCotizacion: false,
      mostrarEnviarCotizacion: false,
      descuentoPorcentaje: 0,
      mostrarDescuento: "initial",
      mostrarBotones: "initial",

      codigoCotizacion: codigoCotizacion,
      idSimulacion: idSimulacion,
      proveedor: { nombre: "" },
      simulador: { nombre: "" },
      consecutivoCotizacion: "",
      linkSimulacion: linkSimulacion,

      archivos: { columns: columnasArchivos, rows: [] },
      columnasArchivos: columnasArchivos,
      presupuesto: "",
      cantidadOferta: "",

      visualizacionBotonSimuladorEntidad: {},
      mostrar: "",
    };
  }
  componentDidMount() {
    this.cargarCotizacion();
    this.cargarSimulacion();
    //this.cargarVisualizacionBotonSimuladorEntidad();
  }

  render() {
    return (
      <>
        <div
          class="menu"
          style={{
            backgroundColor: "#dbe7fc",
            width: "100%",
            padding: "10px",
            fontSize: "12px",
          }}
        >
          <div class="container">
            <InicioBreadcrumbs></InicioBreadcrumbs> /{" "}
            <Link to="/simulaciones">Simulaciones</Link> / Simulacion:{" "}
            <Link to={this.state.linkSimulacion}>
              {" "}
              {this.state.nombreSimulacion}{" "}
            </Link>{" "}
            / Cotizacion: {this.state.consecutivoCotizacion} -{" "}
            {this.state.nombreSimulador} - {this.state.proveedor.nombre}
          </div>
        </div>
        <div
          class="container"
          style={{ minHeight: "550px", paddingTop: "30px" }}
        >
          <div class="subitulosPaginaNotificaciones">
            <b>
              Cotización: {this.state.consecutivoCotizacion} -{" "}
              {this.state.simulador.nombre} - {this.state.proveedor.nombre}
            </b>
          </div>
          <br />

          <br />
          <div class="fila">
            <div
              class="col-lg-7 col-md-7 col-sm-12 mr-auto"
              style={{ paddingLeft: "10px !important" }}
            >
              <table class="table table-bordered table-hover table-sm table-striped dataTable">
                <thead>
                  <tr>
                    <th colSpan="2">Datos</th>
                  </tr>
                </thead>
                <tbody data-test="table-body">
                  {/** <tr>
										<td width = '40%'>Simulador</td>
										<td width = '60%'>{this.state.nombreSimulador}</td>
									</tr> */}
                  <tr>
                    <td>Consecutivo cotización</td>
                    <td>{this.state.consecutivoCotizacion}</td>
                  </tr>

                  <tr style={{ display: this.state.mostrarDatosMontoAgotable }}>
                    <td>Presupuesto</td>
                    <td>{this.state.presupuesto}</td>
                  </tr>
                  <tr style={{ display: this.state.mostrarDatosMontoAgotable }}>
                    <td>Cantidad oferta</td>
                    <td>{this.state.cantidadOferta}</td>
                  </tr>
                  <tr style={{ display: this.state.mostrarDatosMontoAgotable }}>
                    <td>Valor</td>
                    <td>{this.state.stotal}</td>
                  </tr>
                  <tr style={{ display: this.state.mostrarDatosMontoAgotable }}>
                    <td>Valor antes de IVA</td>
                    <td>{this.state.stotalAntesIVACantidad}</td>
                  </tr>
                  <tr style={{ display: this.state.mostrarDatosMontoAgotable }}>
                    <td>IVA</td>
                    <td>{this.state.stotalIVACantidad}</td>
                  </tr>
                  <tr style={{ display: this.state.mostrarDatosMontoAgotable }}>
                    <td>Descuento</td>
                    <td>{this.state.sdescuentoCantidad}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <br />
          <Tabs>
            <Tab eventKey="items" title="Items">
              <div style={{ whiteSpace: "pre-wrap" }}>
                <br />
                <MDBDataTable
                  striped
                  bordered
                  small
                  data={this.state.datos}
                  hover
                  entriesOptions={[5, 10, 25, 100, 1000]}
                  entries={1000}
                  pagesAmount={4}
                  condensed
                />
              </div>
            </Tab>
            <Tab eventKey="misArvhivos" title="Mis archivos">
              <div style={{ whiteSpace: "pre-wrap" }}>
                <br />
                <MDBDataTable
                  striped
                  bordered
                  small
                  data={this.state.archivos}
                  hover
                  entriesOptions={[5, 10, 25, 100, 1000]}
                  entries={1000}
                  pagesAmount={4}
                  condensed
                />
              </div>
            </Tab>
          </Tabs>

          <br />
          <br />
          <div class="fila">
            <div class="col-lg-6 col-md-6 col-sm-12 mr-auto"></div>
            <div
              class="col-lg-6 col-md-6 col-sm-12 mr-auto"
              style={{ paddingLeft: "10px !important" }}
            >
              <table class="table table-bordered table-hover table-sm table-striped dataTable">
                <tbody data-test="table-body">
                  <tr>
                    <td width="35%">Subtotal:</td>
                    <td width="65%">{this.state.cotizacion.ssubtotal}</td>
                  </tr>

                  <tr>
                    <td width="35%">Total IVA:</td>
                    <td width="65%">{this.state.cotizacion.stotalIVA}</td>
                  </tr>
                  <tr>
                    <td width="35%">Total Descuento:</td>
                    <td width="65%">{this.state.cotizacion.stotalDescuento}</td>
                  </tr>

                  <tr>
                    <td width="35%">Total:</td>
                    <td width="65%">{this.state.cotizacion.stotal}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <br />
          <br />
          {/**
				// ------------------------------------------------------------------------------------------------------
				// ItemCotizacion
				// ------------------------------------------------------------------------------------------------------
				 */}

          <Modal
            show={this.state.mostrarIVATodosProductos}
            onHide={this.handleCloseIVATodosProductos.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>IVA todos los productos</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form
                onSubmit={this.formularioModificarIVATodosProductos.bind(this)}
              >
                IVA
                <br />
                <input
                  type="text"
                  className="form-control"
                  placeholder="IVA todos productos"
                  value={this.state.ivaTodosProductosModificar}
                  onChange={this.ivaTodosProductosModificar.bind(this)}
                />
                <br />
                <br />
                {this.state.respuestaActualizacionMasiva}
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseIVATodosProductos.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.modificarIVATodosProductos.bind(this)}
              >
                Actualizar
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarDescuentoTodosProductos}
            onHide={this.handleCloseDescuentoTodosProductos.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Descuento todos los productos</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form
                onSubmit={this.formularioModificarDescuentoTodosProductos.bind(
                  this
                )}
              >
                Descuento
                <br />
                <input
                  type="text"
                  className="form-control"
                  placeholder="Descuento todos productos"
                  value={this.state.descuentoTodosProductos}
                  onChange={this.descuentoTodosProductosModificar.bind(this)}
                />
                <br />
                <br />
                {this.state.respuestaActualizacionMasiva}
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseDescuentoTodosProductos.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.modificarDescuentoTodosProductos.bind(this)}
              >
                Actualizar
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarCerrarCotizacion}
            onHide={this.handleCloseCerrarCotizacion.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Última oferta</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              ¿Esta es su última oferta?, si la envía ud no podrá realizar
              ningún cambio adicional.
              <br />
              {this.state.respuestaCerrarCotizacion}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseCerrarCotizacion.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.cerrarCotizacion.bind(this)}
              >
                Última oferta
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.mostrarEditarItemCotizacion}
            onHide={this.handleCloseEditarItemCotizacion.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Editar item</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={this.formularioEditarItemCotizacion.bind(this)}>
                IVA
                <br />
                <input
                  type="text"
                  className="form-control"
                  placeholder="IVA"
                  value={this.state.ivaEditar}
                  onChange={this.actualizarIVAEditar.bind(this)}
                />
                <br />
                Precio unitario antes impuestos
                <br />
                <input
                  type="text"
                  className="form-control"
                  placeholder="Precio unitario antes impuestos"
                  value={this.state.precioUnitarioAntesImpuestos}
                  onChange={this.actualizarPrecioUnitarioAntesImpuestosEditar.bind(
                    this
                  )}
                />
                <br />
                <div
                  style={{
                    display: this.state.requiereEdicionProveedor
                      ? "none"
                      : this.state.mostrarDescuento,
                  }}
                >
                  Porcentaje descuento
                  <br />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Descuento del itemCotizacion"
                    value={this.state.descuentoPorcentaje}
                    onChange={this.descuentoPorcentajeEditar.bind(this)}
                  />
                  <br />
                </div>
                <br />
                {this.state.respuestaEditarItemCotizacion}
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCloseEditarItemCotizacion.bind(this)}
              >
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={this.editarItemCotizacion.bind(this)}
              >
                Editar
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </>
    );
  }

  // ------------------------------------------------------------------------------------------------------
  // ItemCotizacion
  // ------------------------------------------------------------------------------------------------------
  handleCloseInsertarItemCotizacion(event) {
    this.setState({ mostrarInsertarItemCotizacion: false });
  }
  handleCloseEditarItemCotizacion(event) {
    this.setState({ mostrarEditarItemCotizacion: false });
  }
  handleCloseEliminarItemCotizacion(event) {
    this.setState({ mostrarEliminarItemCotizacion: false });
  }
  handleCloseDescuentoTodosProductos(event) {
    this.setState({ mostrarDescuentoTodosProductos: false });
  }
  handleCloseIVATodosProductos(event) {
    this.setState({ mostrarIVATodosProductos: false });
  }
  handleCloseCerrarCotizacion() {
    this.setState({ mostrarCerrarCotizacion: false });
  }
  handleCloseEnviarCotizacion() {
    this.setState({ mostraEnviarCotizacion: false });
  }
  // ----------------------------------------
  // Descuento todos productos
  // ----------------------------------------
  descuentoTodosProductosModificar(event) {
    var descuentoTodosProductos = event.target.value;
    this.setState({ descuentoTodosProductos: descuentoTodosProductos });
  }
  ivaTodosProductosModificar(event) {
    var ivaTodosProductosModificar = event.target.value;
    this.setState({ ivaTodosProductosModificar: ivaTodosProductosModificar });
  }
  handleShowModificarIVATodosProductos() {
    this.setState({ mostrarIVATodosProductos: true });
  }
  handleShowEnviarCotizacion() {
    this.setState({ mostrarCerrarCotizacion: true });
  }

  handleShowModificarDescuentoTodosProductos() {
    this.setState({ mostrarDescuentoTodosProductos: true });
  }

  formularioModificarIVATodosProductos(event) {
    event.preventDefault();
    this.modificarIVATodosProductos();
  }
  modificarIVATodosProductos() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var iva = this.state.ivaTodosProductosModificar;

    var info = { codigo: codigo, idCotizacion: idCotizacion, iva: iva };
    this.setState({ respuestaActualizacionMasiva: "Actualizando" });
    axios
      .post(
        misConstantes.URL_CONSULTA +
          "/ServletModificarIVATodosProductosCotizacion",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          var mensaje = respuesta.mensaje;
          this.setState({ respuestaActualizacionMasiva: mensaje });
          if (respuesta.respuesta == "exito") {
            setTimeout(
              function () {
                this.setState({
                  mostrarIVATodosProductos: false,
                  respuestaActualizacionMasiva: "",
                });
              }.bind(this),
              1000
            );
            this.cargarCotizacion();
            //				this.cargarItemCotizacions();
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }
  formularioModificarDescuentoTodosProductos(event) {
    event.preventDefault();
    this.modificarDescuentoTodosProductos();
  }
  modificarDescuentoTodosProductos() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var descuento = this.state.descuentoTodosProductos;

    var info = {
      codigo: codigo,
      idCotizacion: idCotizacion,
      descuento: descuento,
    };
    this.setState({ respuestaActualizacionMasiva: "Actualizando" });
    axios
      .post(
        misConstantes.URL_CONSULTA +
          "/ServletModificarDescuentoTodosProductosCotizacion",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          var mensaje = respuesta.mensaje;
          this.setState({ respuestaActualizacionMasiva: mensaje });
          if (respuesta.respuesta == "exito") {
            setTimeout(
              function () {
                this.setState({
                  mostrarDescuentoTodosProductos: false,
                  respuestaActualizacionMasiva: "",
                });
              }.bind(this),
              1000
            );
            this.cargarCotizacion();
            //				this.cargarItemCotizacions();
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }
  // ----------------------------------------
  // Cargar ItemCotizacion
  // ----------------------------------------
  cargarSimulacion() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idSimulacion = this.state.idSimulacion;

    var info = { codigo: codigo, idSimulacion: idSimulacion };
    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletSimulacionCotizacionTercero",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var simulacion = response.data;
          var eventoCotizacion = this.state.eventoCotizacion;
          if (simulacion.eventoCotizacion != null) {
            eventoCotizacion = simulacion.eventoCotizacion;
          }
          var nombreSimulacion =
            simulacion.simulador.nombre + " - " + simulacion.fechaCreacion;
          var nombreSimulador = simulacion.simulador.nombre;

          var mostrar = "";
          var mostrarDatosMontoAgotable = "";
          if (simulacion.simulador.tipo == 1) {
            mostrar = "none";
            mostrarDatosMontoAgotable = "none";
          }

          this.setState({
            simulacion: simulacion,
            eventoCotizacion: eventoCotizacion,
            nombreSimulacion: nombreSimulacion,
            nombreSimulador: nombreSimulador,
            mostrar: mostrar,
            mostrarDatosMontoAgotable: mostrarDatosMontoAgotable,
          });
        }.bind(this)
      )
      .catch(function (error) {});
  }

  cargarCotizacion() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var codigoCotizacion = this.state.codigoCotizacion;
    var idSimulacion = this.state.idSimulacion;
    //		alert(codigo + " ---  " + codigoCotizacion + " -- " + idSimulacion );
    var info = {
      codigo: codigo,
      codigoCotizacion: codigoCotizacion,
      idSimulacion: idSimulacion,
    };

    axios
      .post(misConstantes.URL_CONSULTA + "/ServletCotizacionCotizacion", info, {
        params: info,
      })
      .then(
        function (response) {
          //			alert("-----");
          var cotizacion = response.data;
          //			alert( JSON.stringify(cotizacion) ); ServletCotizacionCotizacion

          var consecutivoCotizacion = cotizacion.consecutivo;
          //			alert(JSON.stringify(cotizacion)  );
          var proveedor = cotizacion.proveedor;
          var simulador = cotizacion.simulador;
          var presupuesto = cotizacion.spresupuesto;
          var cantidadOferta = cotizacion.scantidadOfertada;

          // 		jcotizacion.put("scantidadInicial", NumberFormat.getInstance().format( (long)  getCantidadInicial()  )  );
          //		jcotizacion.put("scantidadOfertada", NumberFormat.getInstance().format( (long)  getCantidadOfertada()  )  );
          //		jcotizacion.put("spresupuesto", NumberFormat.getInstance().format( (long)  getPresupuesto()  )  );

          var stotal = cotizacion.stotal;
          var stotalAntesIVACantidad = cotizacion.stotalAntesIVACantidad;
          var stotalIVACantidad = cotizacion.stotalIVACantidad;
          var sdescuentoCantidad = cotizacion.sdescuentoCantidad;

          var mostrarBotones = "initial";

          this.setState({
            presupuesto: presupuesto,
            stotal: stotal,
            stotalAntesIVACantidad: stotalAntesIVACantidad,
            stotalIVACantidad: stotalIVACantidad,
            sdescuentoCantidad: sdescuentoCantidad,
            cantidadOferta: cantidadOferta,
            proveedor: proveedor,
            simulador: simulador,
            cotizacion: cotizacion,
            mostrarBotones: mostrarBotones,
            consecutivoCotizacion: consecutivoCotizacion,
          });
          this.cargarItemCotizacions();
          this.cargarArchivoProveedorProcesoSimulacions();
        }.bind(this)
      )
      .catch(function (error) {});
  }
  cargarItemCotizacions() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idSimulacion = this.state.idSimulacion;
    var codigoCotizacion = this.state.codigoCotizacion;
    var info = {
      codigo: codigo,
      idSimulacion: idSimulacion,
      codigoCotizacion: codigoCotizacion,
    };

    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletItemsCotizacionCotizacionTercero",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var datosFinales = response.data;
          //			var cotizacion = this.state.cotizacion;
          var columns = this.state.columnasCerrado;
          var rows = [];

          for (var i = 0; i < datosFinales.length; i++) {
            const identificador = datosFinales[i].id + "";
            var nombre = datosFinales[i].texto;
            if (nombre != datosFinales[i].referencia) {
              nombre = datosFinales[i].referencia + ". " + nombre;
            }

            var sprecioSimulacion = "";
            var ssubtotalPrecioSimulacion = "";
            if (datosFinales[i].sprecioSimulacion != -1) {
              sprecioSimulacion = datosFinales[i].sprecioSimulacion;
              ssubtotalPrecioSimulacion =
                datosFinales[i].ssubtotalPrecioSimulacion;
            }
            // var valoresSimulacion = ReactHtmlParser( "Uni: " + sprecioSimulacion +  "<br/>Sub: " + ssubtotalPrecioSimulacion)
            var valoresSimulacion = ReactHtmlParser(
              datosFinales[i].sprecioUnitarioAntesImpuestos +
                "<br/>Desc: " +
                datosFinales[i].ssubtotalUnitarioDescuento
            );
            if (datosFinales[i].calculoFormula == true) {
              valoresSimulacion = ReactHtmlParser(
                datosFinales[i].sprecioUnitarioAntesImpuestos +
                  "<br/>Desc: " +
                  datosFinales[i].ssubtotalUnitarioDescuento +
                  "<br/>Final: " +
                  datosFinales[i].svalorCatalogo
              );
            }
            var iva = ReactHtmlParser(
              "%: " +
                datosFinales[i].stotalImpuestosPositivos +
                "<br/>Val: " +
                datosFinales[i].svalorImpuestosPositivos
            );
            var descuento = ReactHtmlParser(
              "%: " +
                datosFinales[i].sdescuentoPorcentaje +
                "<br/>Val: " +
                datosFinales[i].sdescuentoValor
            );

            var row = {
              texto: nombre,
              precioSimulacion: valoresSimulacion,
              precioUnitarioAntesImpuestos:
                datosFinales[i].sprecioUnitarioAntesImpuestos,
              cantidad: datosFinales[i].cantidad,
              totalImpuestosPositivos: iva,
              descuento: descuento,
              subtotal: datosFinales[i].ssubtotal,

              botones: (
                <div style={{ width: "100%", textAlign: "center" }}>
                  <a
                    href=""
                    onClick={(event) =>
                      this.handleShowEditarItemCotizacion(
                        event,
                        identificador + ""
                      )
                    }
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                </div>
              ),
            };
            rows.push(row);
          }

          var datos = { columns: columns, rows: rows };
          this.setState({ datos: datos });
        }.bind(this)
      )
      .catch(function (error) {});
  }

  // ----------------------------------------
  // Editar ItemCotizacion
  // ----------------------------------------
  handleShowEditarItemCotizacion(event, id) {
    event.preventDefault();
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    this.setState({
      mostrarEditarItemCotizacion: true,
      idItemCotizacionEditar: id,
      respuestaEditarItemCotizacion: "Cargando",
      requiereEdicionProveedor: false,
    });
    var info = { codigo: codigo, idCotizacion: idCotizacion, id: id };
    axios
      .post(misConstantes.URL_CONSULTA + "/ServletItemCotizacion", info, {
        params: info,
      })
      .then(
        function (response) {
          var itemCotizacion = response.data;

          const ivaEditar = itemCotizacion.totalImpuestosPositivos;
          const precioUnitarioAntesImpuestos =
            itemCotizacion.precioFinalUnitario;
          const descuentoPorcentaje = itemCotizacion.descuentoPorcentaje;
          const precioUnitarioSimulacion = itemCotizacion.precioSimulacion;
          const textoItem =
            (itemCotizacion.texto || "") + " " + (itemCotizacion.referencia || "");
          const esLogistica =
            textoItem.toLowerCase().indexOf("logistica") >= 0 ||
            textoItem.toLowerCase().indexOf("logística") >= 0;
          const requiereEdicionProveedor =
            itemCotizacion.requiereEdicionProveedor + "" == "true" ||
            esLogistica;

          var mostrarDescuento = "initial";
          if (precioUnitarioSimulacion == -1) {
            mostrarDescuento = "none";
          }
          if (requiereEdicionProveedor) {
            mostrarDescuento = "none";
          }
          this.setState({
            mostrarDescuento: mostrarDescuento,
            ivaEditar: ivaEditar,
            precioUnitarioAntesImpuestos: precioUnitarioAntesImpuestos,
            descuentoPorcentaje: descuentoPorcentaje,
            idEditarItemCotizacion: id,
            precioUnitarioSimulacion: precioUnitarioSimulacion,
            requiereEdicionProveedor: requiereEdicionProveedor,
            respuestaEditarItemCotizacion: "",
          });
        }.bind(this)
      )
      .catch(function (error) {});
  }

  //	{actualizarIVAEditar - ivaEditar    precioUnitarioAntesImpuestos - actualizarPrecioUnitarioAntesImpuestosEditar     descuentoPorcentaje -  descuentoPorcentajeEditar  }
  actualizarIVAEditar(event) {
    var ivaEditar = event.target.value;
    this.setState({ ivaEditar: ivaEditar });
  }
  actualizarPrecioUnitarioAntesImpuestosEditar(event) {
    var precioUnitarioAntesImpuestos = event.target.value;
    var precioUnitarioSimulacion = this.state.precioUnitarioSimulacion;
    var descuentoPorcentaje = 0;
    if (
      this.state.precioUnitarioSimulacion < 0 ||
      (precioUnitarioSimulacion == 0 && this.state.requiereEdicionProveedor)
    ) {
      this.setState({
        precioUnitarioAntesImpuestos: precioUnitarioAntesImpuestos,
        descuentoPorcentaje: descuentoPorcentaje,
      });
    } else {
      var descuentoPorcentaje =
        ((precioUnitarioSimulacion - precioUnitarioAntesImpuestos) /
          precioUnitarioSimulacion) *
        100;
      this.setState({
        precioUnitarioAntesImpuestos: precioUnitarioAntesImpuestos,
        descuentoPorcentaje: descuentoPorcentaje,
      });
    }
  }
  descuentoPorcentajeEditar(event) {
    var descuentoPorcentaje = event.target.value;
    var precioUnitarioSimulacion = this.state.precioUnitarioSimulacion;
    var precioUnitarioAntesImpuestos = this.state.precioUnitarioAntesImpuestos;
    if (!(precioUnitarioSimulacion == 0 && this.state.requiereEdicionProveedor)) {
      precioUnitarioAntesImpuestos =
        (precioUnitarioSimulacion * (100 - descuentoPorcentaje)) / 100;
    }

    this.setState({
      precioUnitarioAntesImpuestos: precioUnitarioAntesImpuestos,
      descuentoPorcentaje: descuentoPorcentaje,
    });
  }
  formularioEditarItemCotizacion(event) {
    event.preventDefault();
    this.editarItemCotizacion(event);
  }
  editarItemCotizacion(event) {
    this.setState({ respuestaEditarItemCotizacion: "Editando" });

    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;
    var id = this.state.idEditarItemCotizacion;
    var descuentoPorcentaje = this.state.descuentoPorcentaje;
    var precioUnitarioAntesImpuestos = this.state.precioUnitarioAntesImpuestos;
    var iva = this.state.ivaEditar;

    var info = {
      codigo: codigo,
      id: id,
      idCotizacion: idCotizacion,
      descuento: descuentoPorcentaje,
      precioUnitarioAntesImpuestos: precioUnitarioAntesImpuestos,
      iva: iva,
    };

    this.setState({ respuestaEditarItemCotizacion: "Actualizando" });

    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletActualizarItemCotizacion",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          var mensaje = respuesta.mensaje;
          this.setState({ respuestaEditarItemCotizacion: mensaje });
          if (respuesta.respuesta == "exito") {
            setTimeout(
              function () {
                this.setState({
                  mostrarEditarItemCotizacion: false,
                  respuestaEditarItemCotizacion: "",
                });
              }.bind(this),
              1000
            );
            this.cargarCotizacion();
            //				this.cargarItemCotizacions();
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }
  // ----------------------------------------
  // Cerrar cotizacion
  // ----------------------------------------
  cerrarCotizacion(event) {
    this.setState({ respuestaCerrarCotizacion: "Enviando" });

    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCotizacion = this.state.idCotizacion;

    var info = { codigo: codigo, idCotizacion: idCotizacion };

    axios
      .post(misConstantes.URL_CONSULTA + "/ServletCerrarCotizacion", info, {
        params: info,
      })
      .then(
        function (response) {
          var respuesta = response.data;
          var mensaje = respuesta.mensaje;
          this.setState({ respuestaCerrarCotizacion: mensaje });
          if (respuesta.respuesta == "exito") {
            window.location.reload();
          }
        }.bind(this)
      )
      .catch(function (error) {});
  }
  handleIrASimulacion(event) {
    window.location.href = "/simulacion/" + this.state.idSimulacion;
  }

  cargarArchivoProveedorProcesoSimulacions() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var codigoCotizacion = this.state.codigoCotizacion;
    var idSimulacion = this.state.idSimulacion;
    var info = {
      codigo: codigo,
      codigoCotizacion: codigoCotizacion,
      idSimulacion: idSimulacion,
    };
    //		var cotizacion = this.state.cotizacion;
    axios
      .post(
        misConstantes.URL_CONSULTA +
          "/ServletArchivoProveedorCotizacionTercero",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var datosFinales = response.data;

          //			alert( JSON.stringify( datosFinales ) );

          var columns = this.state.columnasArchivos;

          var rows = [];
          for (var i = 0; i < datosFinales.length; i++) {
            const identificador = datosFinales[i].id + "";
            var urlDescarga =
              misConstantes.URL_CONSULTA +
              "/descargarArchivoProveedorCotizacion?idSimulacion=" +
              idSimulacion +
              "&codigoCotizacion=" +
              codigoCotizacion +
              "&id=" +
              identificador;
            //				alert( urlDescarga );
            var row = {
              nombre: <a href={urlDescarga}>{datosFinales[i].nombre}</a>,
              descripcion: datosFinales[i].descripcion,
            };
            rows.push(row);
          }
          var archivos = { columns: columns, rows: rows };
          this.setState({ archivos: archivos });
        }.bind(this)
      )
      .catch(function (error) {});
  }

  // descargarCotizacionMantenimiento(){
  // 	var  codigoCotizacion = this.state.codigoCotizacion;
  // 	window.open(misConstantes.URL_CONSULTA + '/mantenimientoVehiculos.xlsx?codigoCotizacion=' + codigoCotizacion, "_blank");

  // }
  descargarCotizacionMantenimiento() {
    const { codigoCotizacion } = this.state;

    const url = `${misConstantes.URL_CONSULTA}/mantenimientoVehiculos.xlsx?codigoCotizacion=${codigoCotizacion}`;

    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const urlBlob = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = urlBlob;
        a.download = `mantenimiento_${codigoCotizacion}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(urlBlob);
      })
      .catch((error) => {
        console.error("Error al descargar el archivo de mantenimiento:", error);
      });
  }

  //   descargarCotizacion() {
  //     var codigoCotizacion = this.state.codigoCotizacion;
  //     var idSimulacion = this.state.idSimulacion;
  //     window.open(
  //       misConstantes.URL_CONSULTA +
  //         "/cotizacion.xlsx?codigoCotizacion=" +
  //         codigoCotizacion +
  //         "&idSimulacion=" +
  //         idSimulacion,
  //       "_blank"
  //     );
  //   }

  descargarCotizacion() {
    const { codigoCotizacion, idSimulacion } = this.state;

    const url = `${misConstantes.URL_CONSULTA}/cotizacion.xlsx?codigoCotizacion=${codigoCotizacion}&idSimulacion=${idSimulacion}`;

    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const urlBlob = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = urlBlob;
        a.download = `cotizacion_${codigoCotizacion}_${idSimulacion}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(urlBlob);
      })
      .catch((error) => {
        console.error("Error al descargar la cotización:", error);
      });
  }

  cargarVisualizacionBotonSimuladorEntidad() {
    var codigo = localStorage.getItem("codigoUsuario");
    var idSimulacion = this.state.idSimulacion;

    var info = { codigo: codigo, idSimulacion: idSimulacion };

    axios
      .post(
        misConstantes.URL_CONSULTA +
          "/ServletVisualizacionBotonSimuladorEntidad",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var respuesta = response.data;
          //			alert( JSON.stringify(respuesta) );

          var insertarArchivo = "";
          if (respuesta.insertarArchivo == false) {
            insertarArchivo = "none";
          }
          var editarCantidad = "";
          if (respuesta.editarCantidad == false) {
            editarCantidad = "none";
          }
          var insertarItemBlanco = "";
          if (respuesta.insertarItemBlanco == false) {
            insertarItemBlanco = "none";
          }
          var descargaArchivoMantenimiento = "";
          if (respuesta.descargaArchivoMantenimiento == false) {
            descargaArchivoMantenimiento = "none";
          }
          var editarSimulacion = "";
          if (respuesta.editarSimulacion == false) {
            editarSimulacion = "none";
          }
          var insertarGravamen = "";
          if (respuesta.insertarGravamen == false) {
            insertarGravamen = "none";
          }

          var visualizacionBotonSimuladorEntidad = {
            insertarArchivo: insertarArchivo,
            editarCantidad: editarCantidad,
            insertarItemBlanco: insertarItemBlanco,
            descargaArchivoMantenimiento: descargaArchivoMantenimiento,
            editarSimulacion: editarSimulacion,
            insertarGravamen: insertarGravamen,
          };
          this.setState({
            visualizacionBotonSimuladorEntidad:
              visualizacionBotonSimuladorEntidad,
          });

          //			"estado":1,"insertarArchivo":true,"editarCantidad":true,"insertarItemBlanco":true,"descargaArchivoMantenimiento":true,"editarSimulacion":true,"insertarGravamen":true,"id":1}
        }.bind(this)
      )
      .catch(function (error) {
        alert("11111");
      });
  }
}

export default CotizacionTercero;
